import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'LlIcon',
  props: {
  icon: { type: String, default: undefined },
  color: { type: String, default: undefined },
  size: { type: [String, Number], default: undefined },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(_component_v_icon, {
    icon: __props.icon,
    color: __props.color,
    size: __props.size
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["icon", "color", "size"]))
}
}

})